module.exports = __webpack_public_path__ + "img/treatments-directory-card-desktop-fr.b4ba994d.jpg";